import { __awaiter, __generator, __read } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { useMutation } from '@office-start/data-fetching';
import { fetchEncryptionKey, fetchIdentity, } from '@office-start/identity-service';
import { fetchRecommendedConfig } from '@office-start/recommended-config-service';
import { useMemo, useRef } from 'react';
import { getQueryKey } from '../getQueryKey';
import { getRecommendedDataProvider } from '../getRecommendedDataProvider';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useSuggestedTasksActionsMutation(providerType) {
    var _this = this;
    var queryKey = useMemo(function () {
        return getQueryKey(providerType);
    }, [providerType]);
    var dataProvider = useMemo(function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, componentContext, identity, recommendedConfig, encryptionKey, providerProps, dataManagerModule;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        fetchOfficeComponentContext(),
                        fetchIdentity(),
                        fetchRecommendedConfig(),
                        fetchEncryptionKey(),
                    ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 4]), componentContext = _a[0], identity = _a[1], recommendedConfig = _a[2], encryptionKey = _a[3];
                    if (!recommendedConfig ||
                        !componentContext ||
                        !identity ||
                        !encryptionKey) {
                        return [2 /*return*/, Promise.reject('Missing RecommendedConfig')];
                    }
                    providerProps = {
                        providerType: providerType,
                        identity: identity,
                        officeComponentContext: componentContext,
                        recommendedConfig: recommendedConfig,
                        encryptionKeyResult: encryptionKey,
                    };
                    return [4 /*yield*/, getRecommendedDataProvider(providerProps.providerType)()];
                case 2:
                    dataManagerModule = _b.sent();
                    return [2 /*return*/, dataManagerModule
                            ? dataManagerModule.getDataManager(providerProps)
                            : undefined];
            }
        });
    }); }, [providerType]);
    var provider = useRef();
    return useMutation(function (actionProps) { return __awaiter(_this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            if ((_a = provider.current) === null || _a === void 0 ? void 0 : _a.performActions) {
                return [2 /*return*/, provider.current.performActions(actionProps)];
            }
            return [2 /*return*/];
        });
    }); }, {
        onMutate: function (actionProps) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = provider;
                        return [4 /*yield*/, dataProvider];
                    case 1:
                        _a.current = _c.sent();
                        if ((_b = provider.current) === null || _b === void 0 ? void 0 : _b.onPerformActionsCallback) {
                            provider.current.onPerformActionsCallback(actionProps);
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        onSuccess: function (_data, actionProps) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                if ((_a = provider.current) === null || _a === void 0 ? void 0 : _a.onPerformActionsSuccessCallback) {
                    provider.current.onPerformActionsSuccessCallback(actionProps, queryKey);
                }
                return [2 /*return*/];
            });
        }); },
        onError: function (_error, actionProps) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                if ((_a = provider.current) === null || _a === void 0 ? void 0 : _a.onPerformActionsErrorCallback) {
                    provider.current.onPerformActionsErrorCallback(actionProps);
                }
                return [2 /*return*/, _error];
            });
        }); },
    });
}
//# sourceMappingURL=useSuggestedTasksActionsMutation.js.map